import { Component, ElementRef, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Action, ActionType } from './action';

@Component({
  selector: 'rl-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss', './menu.component-rtl.css']
})
export class MenuComponent implements OnInit {
  _actions = [];
  @Input() set actions(actions: Array<Action | ActionType>) {
    this._actions = [];
    actions.forEach((a) => {
      if (typeof a === 'string') {
        a = { code: a };
      }
      a.classes = this.classes(a);
      this._actions.push(a);
    });
  }

  @Input() elementName?: 'citation' | 'list' | 'section' | 'annotation';

  @Output() onClick: EventEmitter<string> = new EventEmitter<string>();

  displayMenu: boolean = false;
  uniqueId: string;

  constructor(private e: ElementRef) {}

  ngOnInit(): void {
    this.uniqueId = this.e.nativeElement.id;
  }

  clickAction(action: Action) {
    if (action.disable) return;
    this.onClick.emit(action.code);
    this.displayMenu = !this.displayMenu;
  }

  classes(action: Action) {
    if (action.actionClass) return action.actionClass + ' ' + (action.ngClass ? action.ngClass : '');
    let classes = action.disable ? 'disabled ' : '';
    switch (action.code) {
      case 'addItems':
        return classes + 'fa fa-plus';
      case 'edit':
        return classes + 'fa fa-pencil';
      case 'setAsPrivate':
        return classes + 'fa fa-user-secret';
      case 'setAsPublic':
        return classes + 'fa fa-globe';
      case 'QUICK_CITE':
        return classes + 'fa fa-quote-right';
      case 'delete':
        return classes + 'fa fa-trash' + (this._actions?.length ? ' divider' : '');
      default:
        return classes + '';
    }
  }
}
